import { Animation, Button, Loader, Spacer, Text, Divider } from '@vinted/web-ui';
import { NOTIFICATIONS_URL } from 'constants/routes';
import useInboxNotificationEvents from 'hooks/useInboxNotificationEvents';
import useTranslate from 'hooks/useTranslate';
import ScrollableArea from 'components/ScrollableArea';
import SeparatedList from 'components/SeparatedList';
import InboxNotificationItem from 'components/InboxNotificationItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const HeaderNotificationDropdown = _ref => {
  let {
    notifications,
    isLoading
  } = _ref;
  const translate = useTranslate();
  const {
    onClick,
    onEnter
  } = useInboxNotificationEvents();

  function renderNotification(notification) {
    return /*#__PURE__*/_jsx(InboxNotificationItem, {
      notification: notification,
      onClick: onClick(notification),
      onEnter: onEnter(notification),
      defaultHighlighted: !notification.isViewed
    }, notification.id);
  }

  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      className: "u-ui-margin-x-large u-flexbox u-justify-content-center",
      "data-testid": "loader",
      children: /*#__PURE__*/_jsx(Loader, {
        size: Loader.Size.Large
      })
    });
  }

  if (!notifications.length) {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-ui-margin-vertical-x-large u-ui-margin-horizontal-x2-large u-flexbox u-flex-direction-column u-align-items-center",
      children: [/*#__PURE__*/_jsx(Animation, {
        animationUrl: "/assets/animations/notifications-empty-state.json",
        size: Animation.Size.Large
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsx(Text, {
        text: translate('header.notifications.empty_state.title'),
        alignment: Text.Alignment.Center,
        type: Text.Type.Title
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Text, {
        text: translate('header.notifications.empty_state.body'),
        alignment: Text.Alignment.Center,
        type: Text.Type.Body,
        html: true
      })]
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ScrollableArea, {
      children: /*#__PURE__*/_jsx("div", {
        className: "header-notification-dropdown__container",
        children: /*#__PURE__*/_jsx(SeparatedList, {
          separator: /*#__PURE__*/_jsx(Divider, {}),
          children: notifications.map(renderNotification)
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "header-notification-dropdown__button-container",
      children: /*#__PURE__*/_jsx(Button, {
        url: NOTIFICATIONS_URL,
        text: translate('header.notifications.see_all'),
        size: Button.Size.Medium
      })
    })]
  });
};

export default HeaderNotificationDropdown;